import { baseApi } from "../baseApi";

export const Salestaxes = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getDoctypeDetails: builder.query({
            query: (params) => ({
                url: `/api/method/frappe.client.get`,
                params: params
            })
        }),
        getTaxcategory: builder.query({
            query: () => `/api/resource/Tax Category`,
        }),
        getAllcompany: builder.query({
            query: () => ({
                url: `/api/resource/Company`,
            })
        }),
        getSalesTaxList: builder.query({
            query: ({ start, limit, filters = [] }) => ({
                url: `/api/resource/Sales Taxes and Charges Template`,
                params: {
                    fields: JSON.stringify([
                        "`tabSales Taxes and Charges Template`.`name`",
                        "`tabSales Taxes and Charges Template`.`owner`",
                        "`tabSales Taxes and Charges Template`.`creation`",
                        "`tabSales Taxes and Charges Template`.`modified`",
                        "`tabSales Taxes and Charges Template`.`modified_by`",
                        "`tabSales Taxes and Charges Template`.`_user_tags`",
                        "`tabSales Taxes and Charges Template`.`_comments`",
                        "`tabSales Taxes and Charges Template`.`_assign`",
                        "`tabSales Taxes and Charges Template`.`_liked_by`",
                        "`tabSales Taxes and Charges Template`.`docstatus`",
                        "`tabSales Taxes and Charges Template`.`idx`",
                        "`tabSales Taxes and Charges Template`.`is_default`",
                        "`tabSales Taxes and Charges Template`.`company`",
                        "`tabSales Taxes and Charges Template`.`title`",
                        "`tabSales Taxes and Charges Template`.`disabled`"
                    ]),
                    filters: JSON.stringify(filters),
                    order_by: "`tabSales Taxes and Charges Template`.`modified` desc",
                    limit_start: start,
                    limit_page_length: limit,

                }
            }),
            providesTags: ['Sales Taxes and Charges Template']
        }),

        getsalestaxCount: builder.query({
            query: () => ({
                url: '/api/method/frappe.desk.reportview.get_count',
                params: {
                    doctype: 'Sales Taxes and Charges Template',
                },
            }),
        }),
        createSalesTaxTemplate: builder.mutation({
            query: (body) => ({
                url: `/api/resource/Sales Taxes and Charges Template`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Sales Taxes and Charges Template'],
        }),
        getSalesTaxTemplateByName: builder.query({
            query: (name) => ({
                url: `/api/resource/Sales Taxes and Charges Template/${encodeURIComponent(name)}`,
                method: "GET",
            }),
            providesTags: ['Sales Taxes and Charges Template']
        }),
        getSalesTaxesAndChargesAccounts: builder.query({
            query: ({ company }) => {
                const filters = {
                    account_type: ["Tax", "Chargeable", "Expense Account"],
                    company: company
                };

                const params = {
                    reference_doctype: "Sales Taxes and Charges",
                    filters: JSON.stringify(filters),
                    doctype: "Account",
                    txt: "",
                    query: "erpnext.controllers.queries.tax_account_query"
                };

                return {
                    url: `/api/method/frappe.desk.search.search_link`,
                    method: 'GET',
                    params
                };
            }
        }),
        updateSalesTaxTemplate: builder.mutation({
            query: ({ name, payload }) => ({
                url: `/api/resource/Sales Taxes and Charges Template/${name}`,
                method: 'PUT',
                body: payload,
            }),
            invalidatesTags: ['Sales Taxes and Charges Template'],
        }),

    }),
});


export const { useUpdateSalesTaxTemplateMutation, useGetSalesTaxListQuery, useGetAllcompanyQuery, useGetTaxcategoryQuery, useGetsalestaxCountQuery, useCreateSalesTaxTemplateMutation, useGetSalesTaxTemplateByNameQuery, useGetSalesTaxesAndChargesAccountsQuery } = Salestaxes
